import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.HierarchyView extends Monitoring.Reports.Executive.AbstractSectionView
  id: 'hierarchy'
  tagName: 'section'
  template: JST["backbone/templates/monitoring/reports/executive/hierarchy"]
  legendsTemplate: JST["backbone/templates/monitoring/reports/executive/hierarchy_legends"]

  initialize: (@options = {}) ->
    @colors = {}
    @colors[@options.settings.accountLabel.codes[0]] = @options.settings.accountLabel.color
    $.each @options.settings.competitorsLabels, (index, label) =>
      @colors[label.codes[0]] = label.color

  render: ->
    @$el.html(@template(brand: @options.settings.accountLabel.codes[0]))
    @bindChartsReady(1)
    @addHierarchy()
    return this

  addHierarchy: ->
    query = @extendedQuery({labels: @options.settings.accountLabel.codes})
    divId = "#brand-hierarchy"
    legendId = "#brand-hierarchy-legend"
    callback = (response, div_id) =>
      response.levels[0] = _.sortBy(response.levels[0], (obj) -> -obj.y)
      @addLabels(response, legendId)
    @_addHierarchy(query, divId, { callback: callback, drillDownFunction: (clickEvent) ->
      {
        tags_node_name: [clickEvent.point.name]
      }
    } )
